import React from 'react';
import loading from '../../static/images/loading.svg';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    overlay: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 99999,
      backgroundColor: 'rgba(33, 33, 33, .25)'
      
    },
    centered: {
      position: 'relative',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    }
  })
)


let Loading = (props: any) => {
  let classes = useStyles();
  return (
    <span>
      {props.isLoading && <div className = {classes.overlay}>
        <img src={loading} alt="Individual" className={classes.centered} />
      </div>}
    </span>
  )
}

export default Loading;